import React from 'react';
import './Report.css';

const data = [
  { id: 1, title: 'Feedback Forms for Alumni', download: '/IQAC/feedback-forms-for-alumni.pdf' },
  { id: 2, title: 'Feedback Forms for Parents', download: '/IQAC/feedback-forms-for-parents.pdf' },
  { id: 3, title: 'Feedback Forms for Teachers', download: '/IQAC/feedback-forms-for-teachers.pdf' },
];

const Report = () => {
  return (
    <div className='main-container-iqac'>
      <div className='container-iqac-image-1'>
      
      </div>
      <div className='container-iqac-About'>
        <div data-aos="flip-left"
             data-aos-easing="ease-out-cubic"
             data-aos-duration="2000">
          <h1>ACTIVITY REPORT/FORM</h1>
          <br />
          <div className="table-wrapper">
            <table className="fl-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Title</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.title}</td>
                    <td>
                      <a href={item.download} download={item.download} className="primary-button">Download</a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default Report;
